import moment from 'moment';
import { useState } from 'react';
import { Button } from 'antd';
import { Link, useSearchParams } from 'react-router-dom';
import styled from 'styled-components';
import { commas } from '../../methods/utils/general-utils';
import { useAppDispatch } from '../../methods/redux/hooks';
import {
	investmentTopUpList,
	migrateInvestmentTopUp,
} from '../../methods/redux/reducers/investment';

interface IInvestmentTopUpItem {
	item: any;
}

const Style = styled.div`
	margin-bottom: 10px;
	padding: 12px;
	background-color: #f8f8f8;

	& .amount {
		font-size: 18px;
	}

	& .title > * {
		display: inline-block;
	}

	& .details {
		margin-top: 10px;
		border-top: 1px dashed #ccc;
		font-size: 14px;
		font-style: italic;

		& .label {
			color: #aaa;
			font-size: 12px;
			font-style: italic;
		}

		& > * {
			display: inline-block;
			padding: 10px;
		}
	}
`;

// const withdrawalStatusColor = (status: any) => {
// 	switch (status) {
// 		case 'cancelled':
// 			return 'gray';

// 		case 'completed':
// 			return 'var(--green-color)';

// 		case 'processing':
// 			return 'blue';

// 		case 'pending':
// 			return 'orange';

// 		case 'review':
// 			return 'yellow';

// 		case 'rejected':
// 			return 'var(--red-color)';

// 		default:
// 			return 'var(--black-color)';
// 	}
// };

const InvestmentTopUpItems = ({ item }: IInvestmentTopUpItem) => {
	const dispatch = useAppDispatch();
	const [state, setState] = useState({
		topUpId: item?._id,
	});
	const [isLoading, setIsLoading] = useState(false);
	const [searchParams] = useSearchParams();

	const submit = async () => {
		const queryData = Object.fromEntries(searchParams.entries());
		setIsLoading(true);
		const response = await dispatch(migrateInvestmentTopUp({ ...state }));
		if (response?.meta?.requestStatus === 'fulfilled') {
			setIsLoading(false);
			dispatch(investmentTopUpList({ ...queryData }));
			setState({ topUpId: '' });
		}
	};
	return (
		<div>
			<Style>
				<div style={{ display: 'flex' }}>
					<div className="title">
						<Link
							to={`/core-modules/investment/top-ups/single?topUpId=${item?._id}`}
							title="View Savings Profile"
						>
							<p>{item.investmentId?.title}</p>
						</Link>
					</div>
					{/* <p style={{ color: 'grey', fontSize: '12px', fontStyle: 'italic' }}>
						Investment title
					</p> */}
					{item && item?.isMigrated === false ? (
						<Button
							style={{ marginLeft: 'auto' }}
							type="primary"
							onClick={() => submit()}
							disabled={isLoading}
						>
							{isLoading ? 'Migrating...' : 'Migrate TopUp'}
						</Button>
					) : null}
				</div>
				<div className="details">
					<div>
						<Link
							title="View Customer Profile"
							to={`/user-profile/${item.userId?._id}`}
						>
							@{item?.userId?.username}
						</Link>
						<p className="label">Customer</p>
					</div>
					<div>
						<p>{item?._id}</p>
						<p className="label">Id</p>
					</div>
					<div>
						<p>{item?.investmentForm}</p>
						<p className="label">Investment Form</p>
					</div>
					<div>
						<p>{item?.investmentId._id}</p>
						<p className="label">InvestmentId</p>
					</div>
					<div>
						<p>
							{item?.investmentFatherCreditId
								? item?.investmentFatherCreditId
								: '--'}
						</p>
						<p className="label">Investment Father Credit Id</p>
					</div>
					<div>
						<p>{item?.proxyStaffId}</p>
						<p className="label">Proxy Staff Id</p>
					</div>
					<div>
						<p>{item?.status}</p>
						<p className="label">Status</p>
					</div>
					<div>
						<p>{item?.transactionStatus}</p>
						<p className="label">Transaction Status</p>
					</div>
					<div>
						<p>{item?.amount}</p>
						<p className="label">Amount</p>
					</div>
					{/* <div>
					<p>
						{commas(item?.calculatedFee?.finalAmount)} {item.currencyId?.symbol}
					</p>
					<p className="label">Final Amount</p>
				</div> */}
					{/* <div>
					<p>
						{commas(item?.calculatedFee?.fee)} {item.currencyId?.symbol}
					</p>
					<p className="label">Fee</p>
				</div> */}
					<div>
						<p>
							{commas(item?.calculatedFee?.discount)} {item.currencyId?.symbol}
						</p>
						<p className="label">Discount</p>
					</div>
					<div>
						<p>
							{commas(item?.calculatedFee?.feeInUsd)} {item.currencyId?.symbol}
						</p>
						<p className="label">Fee in USD</p>
					</div>
					<div>
						<p>{item?.isMigrated ? 'True' : 'False'}</p>
						<p className="label">isMigrated</p>
					</div>
					<div>
						<p>{moment(item.createdAt).format('MMM DD, YY / hh:mm:ss a')}</p>
						<p className="label">Created At</p>
					</div>
					<div>
						<p>{moment(item.updatedAt).format('MMM DD, YY / hh:mm:ss a')}</p>
						<p className="label">Updated At</p>
					</div>
				</div>

				{item?.migrationData && (
					<div style={{ marginTop: '6px' }}>
						<div className="title">
							<p>Migration Data</p>
						</div>
						<div className="details">
							<div>
								<p>{item?.migrationData.customerId}</p>
								<p className="label">CustomerId</p>
							</div>
							<div>
								<p>{item?.migrationData.reference}</p>
								<p className="label">Reference</p>
							</div>
							<div>
								<p>{item?.migrationData.status}</p>
								<p className="label">Status</p>
							</div>
							<div>
								<p>{item?.migrationData?.investment?.investmentId}</p>
								<p className="label">Investment Id</p>
							</div>
							<div>
								<p>{item?.migrationData?.investment?.amountFunded}</p>
								<p className="label">Amount Funded</p>
							</div>
							<div>
								<p>{item?.migrationData?.investment?.currentBalance}</p>
								<p className="label">Current Balance</p>
							</div>
							<div>
								<p>{item?.migrationData?.investment?.totalFunded}</p>
								<p className="label">Total Funded</p>
							</div>
							<div>
								<p>
									{moment(item?.migrationData.createdAt).format(
										'MMM DD, YY / hh:mm:ss a'
									)}
								</p>
								<p className="label">Created At</p>
							</div>
							<div>
								<p>
									{moment(item?.migrationData.updatedAt).format(
										'MMM DD, YY / hh:mm:ss a'
									)}
								</p>
								<p className="label">Updated At</p>
							</div>
						</div>
					</div>
				)}
			</Style>
		</div>
	);
};

export default InvestmentTopUpItems;
